<template>
	<Modals
		class="code-manager-forms-modal"
		:title="'Forms'"
		:validateBeforeClose="validateBeforeClose"
		:display="display"
		@show="close"
		:parentTag="'form'"
		:novalidate="'novalidate'"
		:fullMobile="true"
	>
		<template #modal-content>
			<div class="form-search">
				<div class="form-search__selection">
					<div class="results-toolbar results-toolbar--variant-one">
						<div class="results-toolbar__search">
							<Search
								variant="toggle-icons"
								:placeholder="placeholder"
								v-model.lazy="search"
							/>
						</div>
						<div class="results-toolbar__counter">
							<ResultCounter :counter="formsCount" />
						</div>
					</div>
					<FormSnippetList
						class="form-search__results"
						:forms="formsData"
					/>
				</div>
			</div>
		</template>
		<template #modal-footer>
			<Button
				className="btn--primary"
				labelText="Close"
				:btnClick="close"
			/>
		</template>
	</Modals>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import Search from '@/components/forms/search/search';
import ResultCounter from '@/site-components/result-counter/result-counter';
import Button from '@/components/forms/button/button';
import FormSnippetList from '@/views/code-manager/form-snippet-list';
import { filterAndSortArray } from '@/utils/function';

export default {
	name: 'CodeManagerFormsModal',
	components: {
		Modals,
		Search,
		ResultCounter,
		Button,
		FormSnippetList
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: 'Search forms'
		},
		parentTag: {
			type: String,
			default: 'div'
		},
		validateBeforeClose: {
			type: Boolean,
			default: false
		},
		display: {
			type: Boolean,
			default: false
		},
		forms: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			privilegedUser: true,
			search: '',
			formsData: []
		};
	},
	computed: {
		formsCount() {
			return this.formsData.length;
		}
	},
	methods: {
		close() {
			this.search = '';
			this.formsData = [];
			this.$store.dispatch('codemanager/codeSelectedDetails', {});
			this.$store.dispatch('codemanager/showFormsModal', false);
			this.$emit('show', false);
		},
		filterFormBySearch(val) {
			if (!val) {
				this.formsData = [...this.forms];
				return;
			}
			let result = filterAndSortArray(
				this.forms,
				{
					formName: val.toLowerCase()
				},
				null
			);

			this.formsData = [...result];
		}
	},
	watch: {
		display: {
			handler(val) {
				if (val) {
					let list = [];
					if (this.forms.length) {
						list = [...this.forms];
					}
					this.formsData = list;
				}
			}
		},
		search: {
			deep: true,
			handler(val) {
				this.filterFormBySearch(val);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Code Manager Forms Modal
*/

::v-deep
	.results-toolbar.results-toolbar--variant-one
	.results-toolbar__search {
	@include mq($from: md) {
		width: 100%;
	}
}

::v-deep
	.results-toolbar.results-toolbar--variant-one
	.results-toolbar__counter {
	@include mq($from: md) {
		width: 100%;
	}
}
.code-manager-forms-modal ::v-deep .modal__body {
	&::-webkit-scrollbar-track {
		margin-top: 66px;
	}
}

.form-search {
	&__selection {
		> :first-child {
			position: sticky;
			top: 0;
			background: $white;
			z-index: 20;
		}

		> :last-child {
			position: relative;
			z-index: 10;
		}
	}
}
</style>
